import { useMemo } from 'react';
import { useAuth } from '@practium/features/auth';
import { UserHierarchyLevel, UserRole } from '@practium/shared';
import type { DashboardVariant } from '@practium/features/dashboard';

const mapRoleToVariant = (role?: UserRole): DashboardVariant => {
	switch (role) {
		case UserRole.Farmer:
			return 'farmer';
		case UserRole.Consultant:
			return 'consultant';
		case UserRole.Company:
			return 'company';
		case UserRole.Admin:
			return 'admin';
		default:
			return 'farmer';
	}
};

export const useUserProfile = () => {
	const { user, isLoading } = useAuth();

	const userProfile = useMemo(() => {
		return mapRoleToVariant(user?.role);
	}, [user?.role]);

	const userLevel = useMemo(() => {
		return user?.hierarchyLevel || UserHierarchyLevel.Farmer;
	}, [user?.hierarchyLevel]);

	return {
		userProfile,
		userLevel,
		isLoading,
	};
};
